import type { TOC } from '@ember/component/template-only';
import { PrismBadge } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { eq } from 'ember-truth-helpers';
import { CHANNELS_TABLE_ROW_TYPES } from 'lumen/utils/constants/channel-pricing-constants';

import styles from './td-channels-table-name-cell.module.css';

interface HotelChannelPricingTablesCellsChannelsTableTdChannelsTableNameCellSignature {
  Args: {
    row: {
      type: (typeof CHANNELS_TABLE_ROW_TYPES)[keyof typeof CHANNELS_TABLE_ROW_TYPES];
    };
    value: string;
  };
}

const HotelChannelPricingTablesCellsChannelsTableTdChannelsTableNameCell: TOC<HotelChannelPricingTablesCellsChannelsTableTdChannelsTableNameCellSignature> =
  <template>
    <div
      class="text-200--medium flex flex-row items-center ic-product-tour-49521458-sd-channels-table-row-name-{{@row.type}}"
      data-test-id="channels-table-name-cell"
    >
      <p class="truncate" title={{@value}}>
        {{@value}}
      </p>

      {{#if (eq @row.type CHANNELS_TABLE_ROW_TYPES.PRICING_PARENT_ROW)}}
        <div class={{styles.badge}}>
          <PrismBadge
            @isSmall={{true}}
            @label={{t "channel_pricing.table_name_cell.leading_room"}}
            @type="neutral"
          />
        </div>
      {{/if}}
    </div>
  </template>;

export default HotelChannelPricingTablesCellsChannelsTableTdChannelsTableNameCell;
